function t(r) {
  return r.split("");
}
export {
  t as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_asciiToArray.js
// module id = 1463
// module chunks = 67